<pp-tabs class="tabs" [tabs]="tabs()" (index)="setTab($event)" />

<div class="tabs-content">
  @switch (tab) {
    @case ('info') {
      <pp-personal-info
        [dialogData]="dialogData"
        [readonlyRights]="readonlyRights"
        (unsavedChanges)="handleUnsavedChanges($event, tab)"
        (closeDialog)="closeDialog($event)" />
    }
    @case ('address') {
      <pp-default-address
        [user]="dialogData.user"
        [readonlyRights]="readonlyRights"
        (unsavedChanges)="handleUnsavedChanges($event, tab)"
        (closeDialog)="closeDialog($event)" />
    }
  }
</div>
